/**
 * Ensure background/hero videos play across browsers when format is supported.
 * - Retries play() after canplay
 * - If all sources fail (e.g. WebM-only on iOS), keeps poster / hides broken video chrome
 */
(function () {
  function bindVideo(video) {
    if (!video || video.dataset.mediaVideoBound === '1') return;
    video.dataset.mediaVideoBound = '1';

    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var tryPlay = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {});
      }
    };

    video.addEventListener('loadeddata', tryPlay, { once: true });
    video.addEventListener('canplay', tryPlay);
    function markError() {
      video.classList.add('is-video-error');
      var poster = video.getAttribute('poster');
      var host = video.parentElement;
      if (poster && host) {
        host.style.backgroundImage = 'url("' + poster + '")';
        host.style.backgroundSize = 'cover';
        host.style.backgroundPosition = 'center';
      }
    }

    video.addEventListener('error', function () {
      if (video.error) markError();
    });

    // If every <source> fails, mark the video so CSS can fall back to poster/bg.
    var sources = video.querySelectorAll('source');
    var failed = 0;
    sources.forEach(function (source) {
      source.addEventListener('error', function () {
        failed += 1;
        if (failed >= sources.length) markError();
      });
    });

    tryPlay();
  }

  function scan(root) {
    (root || document)
      .querySelectorAll('video.hero-glow__video, video.hero-banner__video, video.fbscroll__video, video[data-media-video]')
      .forEach(bindVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
